export { default } from './MenuList';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/MenuList/index.js
// module id = 458
// module chunks = 121